// extracted by mini-css-extract-plugin
export default {"itemContent":"vWy4lce9","delegateIcon":"Iy2w1bbY","spenderBadge":"Yux33P2N","pluginIcon":"LpUjVeSb","transactionBanner":"iOGHdkh8"};